<template>
    <div class="search-groups">
        <!-- <select name="search-chooser" id="search-chooser" v-model="groupViewing">
            <option v-for="(search_group, index) in searchGroups" :key='search_group.id' :value="'group-'+index">{{search_group.title}}</option>        
        </select> -->
        <ul class="tabs" id="search-chooser">
            <li v-for="(search_group, index) in searchGroups" :class="[{ selected: groupViewing=='group-'+index }, 'group-'+index ]"  :key='search_group.id' @click="groupViewing='group-'+index">{{ search_group.title }}<input type='checkbox' class="tab-checkbox" v-model="toSendFilters.showOnly" :value="search_group.for_children_of.url"></li>
            <li :class="[{ selected: groupViewing=='group-search'}, 'group-search']" @click="groupViewing='group-search'">Search</li>
        </ul>
        <div v-for="(search_group, index) in searchGroups" :key='search_group.id' :id="'group-'+index" :class="{ hidden: groupViewing!=='group-'+index }">
            <SearchBlock :searchItems='search_group.search' :curIndex='index' :pageType='search_group.page.meta.type' :hasDateFields='search_group.has_date_filter' @filterChange='filters[index].options=$event;' @dateFilterChange='filters[index].dates=$event'/>
        </div>
        <div id="group-search" :class="{ hidden: groupViewing!=='group-search' }">
            <SearchTextBlock @filterChange='toSendFilters.textFilter=$event'/>
        </div>
          <!-- <li><img src="@/assets/images/map-pin-orange.png"> (lodging)</li>
            <li><img src="@/assets/images/map-pin-blue.png"> (restaurants)</li> -->
    </div>
</template>

<script>
import SearchBlock from '@/components/SearchBlock.vue'
import SearchTextBlock from '@/components/SearchTextBlock.vue'
export default{
    name: 'searchgroupsblock',
    data() {
        return {
            data: null,
            groupViewing: 'group-0',
            filters: this.searchGroups.map(item => { 
                return { filter_for: item.for_children_of.url, options: [], dates: null } 
            }),
            toSendFilters: {
                showOnly: this.searchGroups.map(item => item.for_children_of.url),
                filters: [],
                textFilter: '',
            },
        }
    },
    props: {
        searchGroups: {
            type: Array,
            required: true
        }
    },
    components: {
        SearchBlock,
        SearchTextBlock
    },
    watch: {
        filters: {
            handler(val) {
                console.log("Trying to do something.");
                let tempArray = [];
                for (let x in this.filters) {
                    let tempObj = { filter_for: this.filters[x].filter_for, options: [], dates: null };
                    for (let y in this.filters[x].options) {
                        tempObj.options.push(this.filters[x].options[y].options);
                    }
                    tempObj.dates = this.filters[x].dates;
                    tempArray.push(tempObj);
                }
                this.toSendFilters.filters = tempArray;
            },
            deep: true
        },
        toSendFilters: {
            handler(val) {
                this.$emit('filterChange', this.toSendFilters);
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.hidden {
    display: none;
}

#search-chooser {
    background: #333;
    /* background: transparent; */
    border: none;
    border-radius: 0;
    margin: 0;
    position: relative;
    z-index: 2;
    color: #ffffff;
    font-weight: bold;
    font-size: 2rem;
    /* text-align: center; */
}



.tabs {
    list-style-type: none;
}

.tabs li {
    display: inline-block;
    margin-right: 1rem;
    cursor: pointer;
    z-index: 1;
    position: relative;
    padding: .5rem 4rem 0 4rem;
    font-weight: 100;
    position: relative;
    margin-bottom: 0;
    font-family: hardware;
    border-right: 1.5px solid #848484;
    border-top: 1px solid #848484;
    border-top-right-radius: 1rem;
}

.tabs li:not(:first-child){
    margin-left: -2rem;
    padding-left: 4rem;
}

.tabs img{
    width:1.5rem;
}
.tabs li:hover{
    /* color:#ccc; */
     transition: all .15s;
}



/* .tabs li:hover{
    background: #777;
} */

.tabs li.selected {
    /* background-color: #abdf2f; */
    /* background-color: #e4e4e4; */
    z-index: 2;
    color: #333;
}

.tabs li.selected:not(:first-child){
    border-top-left-radius: 1rem;
}

.tab-checkbox {
    margin-left: 1rem;
}

</style>

<style scoped>

.tabs li.selected, .search-filter .top{
    background-color: #e0ff00;
    /* background-color: #1dd974; */
}

#group-0 .search-filter .top, .tabs li.group-0{
    
}

#group-1 .search-filter .top, .tabs li.group-1{
    /* background: #ccc; */
}

#group-1 .search-filter .top{
    
}
</style>